'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TwoOptionTabPane = _react2['default'].createClass({
    displayName: 'TwoOptionTabPane',

    propTypes: {
        image: _react2['default'].PropTypes.string,
        frozenImage: _react2['default'].PropTypes.string,
        title: _react2['default'].PropTypes.string.isRequired,
        heading_1: _react2['default'].PropTypes.string.isRequired,
        description_1: _react2['default'].PropTypes.string.isRequired,
        heading_2: _react2['default'].PropTypes.string.isRequired,
        description_2: _react2['default'].PropTypes.string.isRequired
    },
    getInitialState: function getInitialState() {
        return {
            animating: true
        };
    },
    componentDidMount: function componentDidMount() {

        // TODO: refactor this bit - defer animation handling to whatever
        // is actually animating this component vs making this assumption (CC)
        (0, _setTimeout2['default'])(function () {
            this.setState({ animating: false });
        }.bind(this), 15000);
    },
    render: function render() {
        var button = _react2['default'].createElement(_button2['default'], {
            buttonText: 'Learn more',
            buttonLink: this.props.link || 'http://info.hellosign.com/api-demo.html',
            openInNewWindow: true });

        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'show-for-large-up large-6 columns' },
                _react2['default'].createElement('img', { src: this.state.animating ? this.props.image : this.props.frozenImage, className: 'embedded-image' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'small-12 large-6 small-text-center large-text-left columns' },
                _react2['default'].createElement(
                    'h3',
                    null,
                    this.props.title
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row l-padding-v-20' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-10 large-12 small-centered large-uncentered columns' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'small-5 columns l-no-gutter' },
                            _react2['default'].createElement(
                                'p',
                                { className: 'b' },
                                this.props.heading_1
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                this.props.description_1
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'small-2 columns' },
                            _react2['default'].createElement('img', { src: require('./or.png'), className: 'or-image' })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'small-5 columns l-no-gutter' },
                            _react2['default'].createElement(
                                'p',
                                { className: 'b' },
                                this.props.heading_2
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                this.props.description_2
                            )
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-12 columns' },
                        button
                    )
                )
            )
        );
    }
});

module.exports = TwoOptionTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/two-option-tab-pane.jsx
 ** module id = 860
 ** module chunks = 0
 **/